export const socialAccountFields = {
  facebook: { en: 'Facebook profile link or username', es: 'Enlace o nombre de usuario de Facebook', example: 'facebook.com/your.name' },
  instagram: { en: 'Instagram username or profile link', es: 'Usuario o enlace del perfil de Instagram', example: '@yourname or instagram.com/yourname' },
  tiktok: { en: 'TikTok username or profile link', es: 'Usuario o enlace del perfil de TikTok', example: '@yourname or tiktok.com/@yourname' },
  x_twitter: { en: 'X handle or profile link', es: 'Usuario o enlace del perfil de X', example: '@yourname or x.com/yourname' },
  youtube: { en: 'YouTube channel link or handle', es: 'Enlace del canal o usuario de YouTube', example: 'youtube.com/@yourchannel' },
};
export function parseSocialAccount(platform, input) {
  const text = input.trim();
  const result = { handle: '', profileUrl: '', valid: false };
  if (!text) return result;
  const hosts = { facebook: ['facebook.com','www.facebook.com','m.facebook.com','web.facebook.com','fb.com','www.fb.com','fb.me'], instagram: ['instagram.com','www.instagram.com'], tiktok: ['tiktok.com','www.tiktok.com'], x_twitter: ['x.com','www.x.com','twitter.com','www.twitter.com'], youtube: ['youtube.com','www.youtube.com','m.youtube.com'] };
  const isLink = /^(https?:\/\/|www\.)/i.test(text) || /^[^\s/]+\.[^\s/]+\//.test(text);
  if (!isLink) return { ...result, handle: text, valid: !/\s|[/?#:]|^@$/.test(text) };
  result.profileUrl = text;
  let url;
  try { url = new URL(/^https?:\/\//i.test(text) ? text : `https://${text}`); } catch { return result; }
  if (!hosts[platform]?.includes(url.hostname.toLowerCase()) || url.username || url.password || url.port) return result;
  const parts = url.pathname.split('/').filter(Boolean);
  if (platform === 'youtube') {
    if (parts.length === 1 && /^@.+/.test(parts[0])) { result.handle = parts[0].slice(1); result.valid = true; }
    else result.valid = parts.length === 2 && ['channel','c','user'].includes(parts[0]) && Boolean(parts[1]);
  } else if (platform === 'facebook' && parts[0] === 'profile.php') {
    result.valid = parts.length === 1 && /^\d+$/.test(url.searchParams.get('id') ?? '');
    if (result.valid) result.handle = url.searchParams.get('id') ?? '';
  } else if (platform === 'facebook' && parts[0] === 'people' && parts.length >= 2 && /^\d+$/.test(parts[parts.length - 1])) {
    result.handle = parts[parts.length - 1];
    result.valid = true;
  } else if (parts.length === 1 && !['watch','reel','reels','stories','p','explore','home','login','share','groups','pages','i'].includes(parts[0].toLowerCase())) {
    result.valid = platform !== 'tiktok' || /^@.+/.test(parts[0]);
    if (result.valid && !(platform === 'facebook' && /^\d+$/.test(parts[0]))) result.handle = parts[0].replace(/^@/, '');
  }
  return result;
}
